<template>
  <div class="wrapper__white-bg">
    <div
      class="logo--wrapper"
      v-if="loadStatus && Object.keys(publicProjectDetails).length"
    >
      <router-link to="/">
        <img
          src="../../assets/gemnote_logo_pebble.png"
          alt="gemnote-logo"
          class="logo--wrapper--img"
        />
      </router-link>
    </div>
    <div class="container page-content">
      <Loading v-if="!loadStatus" text="Loading..." />
      <div
        class="flex-center justify-end"
        v-if="loadStatus && !Object.keys(publicProjectDetails).length"
      >
        <div>
          <button
            class="finalize-button"
            :class="{ 'button-loading': finalizingOrder }"
            @click="finalizeOrder"
            v-if="publicProjectDetails.state !== 'wish_list'"
          >
            Finalize
          </button>
        </div>
      </div>
      <template v-if="loadStatus && Object.keys(publicProjectDetails).length">
        <h2 class="page-titles">
          {{ publicProjectDetails.name }}
        </h2>

        <div class="header-content">
          <div class="header-title">
            <h5>Details</h5>
          </div>

          <div class="header-body">
            <div class="flex flex-start">
              <div class="flex-30">
                <div class="content-row">
                  <h5>Due Date</h5>
                  <span>{{
                    publicProjectDetails.inHandsDate
                      ? defaultFormatAndParse(publicProjectDetails.inHandsDate)
                      : 'N/A'
                  }}</span>
                </div>
              </div>
              <div class="flex-70">
                <div class="address-collection">
                  <div class="link-title">
                    <h5 class="inter">Project Link</h5>
                  </div>
                  <div class="link-content">
                    <CopyBanner
                      :text="
                        publicProjectDetails.recipientCollectionAdminOrderUrl
                      "
                      @click="doCopy"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-center mb-3">
              <div class="flex-30">
                <div class="content-row">
                  <p>Submissions</p>
                  <span>{{ publicProjectDetails.numberOfSubmissions }}</span>
                </div>
              </div>
              <div class="flex-70"></div>
            </div>
            <div class="flex flex-end mt-3">
              <div class="flex-30">
                <div class="content-row">
                  <p>CSM</p>
                  <span>{{ publicProjectDetails.customerSuccessManager }}</span>
                </div>
              </div>
              <div class="flex-70">
                <div class="allow-domains">
                  <div class="label">
                    <div>
                      <span> Allowed Domain(s) &nbsp; &nbsp;</span>
                    </div>
                  </div>
                  <div class="domain-tag-input public-domain-tag-input">
                    <input-tag
                      :class="{ 'updating-tags': updatingAllowedDomains }"
                      class="stripped-tags"
                      :validate="validateEmail"
                      :read-only="updatingAllowedDomains"
                      @input="updateWhitelistedDomain"
                      placeholder="Add email domain name"
                      v-model="publicProjectDetails.allowedDomains"
                    ></input-tag>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h6 class="page-sub-titles">Submissions Overview</h6>

        <PublicProjectRecipientsList
          :project-details="publicProjectDetails"
          :apparelSizeNeeded="publicProjectDetails.apparelSizeNeeded"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DateFns from '@/mixins/DateFns'
import { progressStatus } from '../../helpers'
import PublicProjectRecipientsList from '@/components/Projects/PublicProjectRecipientsList'
import CopyBanner from '@/components/Universal/CopyBanner.vue'
import InputTag from 'vue-input-tag'
import { layouts } from '../../helpers'

export default {
  name: 'PublicProject',
  mixins: [DateFns],
  props: ['id'],
  components: {
    PublicProjectRecipientsList,
    InputTag,
    CopyBanner
  },

  beforeCreate() {
    this.$store.dispatch('layout/setPageLayout', layouts.DEFAULT_LAYOUT)
  },
  created() {
    this.$store.dispatch(
      'project/getPublicProjectDetail',
      this.$route.query.token
    )
    // this.$store.dispatch('project/getPublicProjectRecipients', this.$route.query.jwt)
  },
  data: () => ({
    whitelistedDomains: []
  }),
  computed: {
    loadStatus() {
      return progressStatus(this.loadingPublicProjectDetails)
    },

    ...mapState({
      loadingPublicProjectDetails: state =>
        state.project.loadingPublicProjectDetails,
      publicProjectDetails: state => state.project.publicProjectDetails,
      updatingAllowedDomains: state => state.project.updatingAllowedDomains,
      finalizingOrder: state => state.project.finalizingOrder
    })
  },
  methods: {
    doCopy() {
      if (this.publicProjectDetails.recipientCollectionAdminOrderUrl) {
        this.$copyText(
          this.publicProjectDetails.recipientCollectionAdminOrderUrl
        )
        this.$store.dispatch('notification/pushNotification', {
          type: 'success',
          messages: [`Link copied`]
        })
      }
    },

    updateWhitelistedDomain(domains) {
      this.$store.dispatch('project/updateWhitelistedDomain', domains)
    },

    validateEmail(value) {
      // eslint-disable-next-line no-useless-escape
      return /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(
        value
      )
    },

    finalizeOrder() {
      this.$store.dispatch('project/finalizePublicOrder')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.wrapper__white-bg {
  position: absolute;
  width: 100%;
  background-color: #f5f2ee;
  min-height: 100vh;
}

.logo--wrapper {
  position: fixed;
  width: 100%;
  background-color: #f5f2ee;
  padding: 1.875rem 0;
  border-bottom: 2px solid #24292c;
  margin-bottom: 3rem;
  z-index: 9999;

  .logo--wrapper--img {
    width: 50px;
    margin: 0px auto;
  }
}
.page-content {
  margin-top: 10rem;
}

.vgt-wrap__footer {
  font-family: $inter !important;
  color: $onyx;
  background: transparent !important;
}

.header-content {
  border: 1px solid #24292c;
  padding: 3rem;
  margin-top: 0px;

  .header-title {
    text-align: left;
    margin-bottom: 30px;
    font-weight: bold h5 {
      font-family: $editorial;
      font-weight: normal;
      font-size: 1rem;
    }
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    .col:first-child {
      width: 35%;
    }

    .col:last-child {
      width: 62%;
    }
  }

  .content-row {
    display: flex;
    gap: 2rem;
    align-items: center;

    p,
    h5 {
      text-align: left;
      flex-basis: 35%;
      font-weight: bold;
      font-size: 14px;
    }

    span {
      // opacity: 0.5;
      font-size: 14px;
    }
  }

  .content-row:last-child {
    margin-bottom: 0;
  }
}

.address-collection {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start !important;
  margin-bottom: 0rem;

  h5 {
    font-size: 14px !important;
  }
}

.box-details {
  width: 50%;
  padding: 1.5rem;
  margin-top: 2rem;
}

.box-head {
  h5 {
    text-align: left;
    margin-bottom: 1.5rem;
  }

  form {
    width: 65%;
    .form-group {
      margin-bottom: 0 !important;

      input {
        height: 50px !important;
        border: 1px solid $onyx !important;
        padding: 0.5rem 0.5rem !important;
      }
    }
  }
}

.allow-domains {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-end;

  .label {
    flex-basis: 30%;
    //flex-shrink: 0;
    //text-align: left;
    display: flex;
    align-items: center;
    text-align: left;
    font-size: 14px;
    font-weight: bold;

    div {
      display: flex;
    }

    h5 {
      padding-right: 10px;
    }
  }

  .domain-tag-input {
    flex-basis: 70%;
    flex-shrink: 0;

    input {
      display: none !important;
    }
  }
}

.box-content {
  .content-row {
    margin-bottom: 0.5rem;
    display: flex;
    gap: 2rem;
    align-items: center;

    p {
      text-align: left;
      flex-basis: 35%;
      font-weight: 600;
    }

    span {
      opacity: 0.5;
    }
  }
}

.box-copy {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 1rem 0;
}

.link-title {
  flex-basis: 30%;
  text-align: left;
}

.link-content {
  display: flex;
  justify-content: flex-start;
  flex-basis: 70%;
}

.page-titles {
  text-align: center;
  margin-top: 11rem;
  margin-bottom: 1rem;
}

@media (max-width: 900px) {
  .page-content {
    margin-top: 9rem;
  }
  .allow-domains {
    flex-direction: column;
  }
  .header-content {
    padding: 2rem;
    margin-top: 35px;
  }
  .header-body {
    .row {
      flex-direction: column;

      .col {
        width: 100% !important;
      }
    }
  }
  .box-details {
    width: 100%;
  }

  .link-title {
    flex-basis: 100%;
  }

  .box-copy {
    flex-direction: column;
    align-items: flex-start;
  }

  .link-content {
    width: 100%;
    flex-basis: 100%;
  }

  .logo--wrapper {
    padding: 20px 0;
    border-bottom: 1px solid #24292c;

    .logo--wrapper--img {
      width: 50px;
      margin: 0px auto;
    }
  }
}

@media (max-width: 900px) {
  .allow-domains {
    flex-direction: row;
  }
  .page-titles {
    margin-top: 4rem;
    margin-bottom: 2rem;
  }
}

.finalize-button {
  background: #24292c;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  height: 52px;
  width: 8rem;
  padding: 14px;

  &:hover {
    opacity: 0.8;
  }
}

.page-sub-titles {
  text-align: left;
  padding-bottom: 0.5rem;
  padding-top: 2.75rem;
  font-weight: 700;
}

// Utilities
.justify-end {
  justify-content: end;
}

.flex {
  display: flex;
}

.flex-start {
  align-items: flex-start;
}
.flex-end {
  align-items: flex-end;
}
.flex-center {
  align-items: center;
}

.flex-30 {
  flex-basis: 35%;
}
.flex-70 {
  flex-basis: 62%;
}

.mt-3 {
  margin-top: 1rem;
}
.mb-3 {
  margin-bottom: 1rem;
}

@media (max-width: 900px) {
  .header-body .flex {
    flex-direction: column;
    margin-bottom: 1rem;
    gap: 1rem;
  }
  .address-collection {
    gap: 1rem;
  }
  .flex-end {
    align-items: flex-start;
  }
}
</style>
